/**
 * Modal component for adding new lessons
 */

import React from 'react'
import { Modal, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const AddLessonModal = ({ visible, onOk, onCancel, value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Modal
      title={t('v3:add_new_lesson')}
      visible={visible}
      onOk={onOk}
      okText={t('v3:add_lesson')}
      onCancel={onCancel}
      cancelText={t('v4:cancel')}
      centered
      className="add-new-lesson-open"
    >
      <Input
        placeholder={t('v3:add_new_lesson')}
        size="large"
        value={value}
        onChange={onChange}
      />
    </Modal>
  )
}

export default AddLessonModal
